import { datadogRum } from '@datadog/browser-rum';
import packageInfo from '../../../package.json';

/**
 * Used ONLY to initialize DataDog in isolated applications (such as iOS app -> webview).
 * For typical integration within www.carvana.com, ChatUI utilizes the global `window.DD_RUM` object.
 * We do not care who initialized this object; we only care that it exists.
 */
export const DataDogConfigNew = (serviceName: string) => {
  datadogRum.init({
    applicationId: process.env.DATADOG_APPLICATION_ID || '',
    clientToken: process.env.DATADOG_CLIENT_TOKEN || '',
    site: 'datadoghq.com',
    service: serviceName,
    env: process.env.REACT_APP_DATADOG_ENV,
    version: packageInfo.version,
    sampleRate: 100,
    sessionReplaySampleRate: 20,
    trackInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      { match: process.env.CHAT_BACKEND_BASE_URL, propagatorTypes: ['tracecontext'] },
    ],
  });

  datadogRum.startSessionReplayRecording();
};
